import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import styles from './Helpinfo.module.scss';

const cx = classnames.bind(styles);

const HelpInfo = ({ title, phone, desc }) => (
  // eslint-disable-next-line
  <div className={cx('helpinfo')}>
    <h3 className={cx('helpinfo__title')}>{title}</h3>
    <p className={cx('helpinfo__phone')}>{phone}</p>
    {desc && (
      <p className={cx('helpinfo__description')}>{desc}</p>
    )}
  </div>
);

export default HelpInfo;

HelpInfo.propTypes = {
  title: PropTypes.string,
  phone: PropTypes.string,
  desc: PropTypes.string,
};
HelpInfo.defaultProps = {
  title: null,
  phone: null,
  desc: null,
};
